import moment from 'moment';
import normalizeUrl from 'normalize-url';

const formatDuration = (duration, useAbbreviations) => {
  const formatParts = [];
  const daysText = useAbbreviations ? 'd' : ' days';
  const hoursText = useAbbreviations ? 'h' : ' hours';
  const minutesText = useAbbreviations ? 'm' : ' minutes';
  const secondsText = useAbbreviations ? 's' : ' seconds';

  if (duration.days()) {
    formatParts.push(`${duration.days()}${daysText}`);
  }
  if (duration.hours()) {
    formatParts.push(`${duration.hours()}${hoursText}`);
  }
  if (duration.minutes()) {
    formatParts.push(`${duration.minutes()}${minutesText}`);
  }
  if (duration.seconds()) {
    formatParts.push(`${duration.seconds()}${secondsText}`);
  }

  // default display
  if (!formatParts.length) {
    formatParts.push(`${duration.seconds()}${secondsText}`);
  }

  return formatParts.join(' ');
};

export const timeDelta = (seconds = 0, useAbbreviations = true) => {
  const duration = moment.duration(seconds, 'seconds');
  return formatDuration(duration, useAbbreviations);
};

export const url = string => normalizeUrl(string, { stripWWW: false, stripHash: false });

export default { timeDelta, url };
